import {
  getStore,
  getHQStore,
  getStoreWithName
} from "../../../api/services/storeService";
import { logger } from "../../../api/Logger";
import router from "../../../router";
import { getMessageTemplates } from "../../../api/services/MassageTemplateService.js";
import {
  defaultMobileColors,
  defaultDesktopColors
} from "../../../api/constants/colors";
import { DetectMobile } from "../../../mixins/detectmobile";
import { languages } from "../../../../lang/languages.js";
export default {
  state: {
    storeDoc: null,
    ViewConfig: {
      LogIn: false,
      PickUp: false,
      Delivery: false,
      DeliverToRoom: false,
      EatIn: false,
      ShowDeliveryDatePicker: false,
      ShowPickupDatePicker: false,
      HideAddressOnPickup: false,
      ShowTrackingOrderForGuest: false,
      ImageCenterMode: false,
      UiColours: {
        Mobile: {
          Primary: "",
          Secondary: "",
          PrimaryLight: "",
          PrimaryDark: "",
          SecondaryLight: "",
          SecondaryDark: "",
          Accent: "",
          PrimaryText: "",
          Alerts: {
            Info: "",
            success: "",
            Error: ""
          },
          Extras: {
            MenuItemColor: ""
          }
        },
        Desktop: {
          Primary: "",
          Secondary: "",
          PrimaryLight: "",
          PrimaryDark: "",
          SecondaryLight: "",
          SecondaryDark: "",
          Accent: "",
          PrimaryText: "",
          Alerts: {
            Info: "",
            success: "",
            Error: ""
          },
          Extras: {
            MenuItemColor: ""
          }
        }
      }
    },
    storeLoaded: false,
    isGift: false,
    HQDoc: null,
    ThankYouMsg: "",
    HQStore: null,
    MessageTemplates: {},
    selectedLocale: languages[0]
  },
  mutations: {
    setCurrentStoreDoc(state, payload) {
      state.storeDoc = payload;
      var config = state.storeDoc.ViewComponentConfigs;
      InitViewConfig(state, config || {});
    },
    setHQDoc(state, payload) {
      state.HQDoc = payload;
    },
    setHQStore(state, payload) {
      state.HQStore = payload;
    },
    setStoreLoaded(state) {
      state.storeLoaded = true;
    },
    setStoreLoading(state) {
      state.storeLoaded = false;
    },
    setIsGift(state, payload) {
      state.isGift = payload;
    },
    addMessageTemplates(state, payload) {
      state.MessageTemplates[payload.id] = payload.value;
      if (payload.id.trim() === "OrderSuccessfulScreen") {
        state.ThankYouMsg = payload.value;
      }
    },
    clearMessageTemplates(state) {
      state.MessageTemplates = {};
      state.ThankYouMsg = "";
    }
  },
  actions: {
    initStore({ commit }, payload) {
      getStore(payload).onSnapshot(
        function(doc) {
          if (doc.exists) {
            commit("setCurrentStoreDoc", doc.data());
          } else {
            router.replace("/notFoundPage");
          }
        },
        function(reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
          router.replace("/GeneralError");
        }
      );
    },
    initStoreWithName({ commit }, payload) {
      getStoreWithName(payload).onSnapshot(
        function(doc) {
          if (doc.docs.length) {
            commit("setCurrentStoreDoc", doc.docs[0].data());
          } else {
            router.replace("/notFoundPage");
          }
        },
        function(reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
          router.replace("/GeneralError");
        }
      );
    },
    async initHQDoc({ commit }) {
      var hq = await getHQStore().get();
      if (hq.size >= 1) commit("setHQDoc", hq.docs[0].data());
      else commit("setHQDoc", null);
    },
    initMessageTemplates({ commit }, payload) {
      commit("clearMessageTemplates");
      getMessageTemplates(payload).onSnapshot(
        function(data) {
          if (data.docs) {
            data.docs.forEach(function(doc) {
              commit("addMessageTemplates", {
                id: doc.id.trim(),
                value: doc.data().template
              });
            });
          }
        },
        function(reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
        }
      );
    }
  },
  getters: {
    selectedLocale(state) {
      return state.selectedLocale;
    },
    getMessageTemplates(state) {
      return state.MessageTemplates;
    },
    getThankYouMessage(state) {
      return state.ThankYouMsg || "Your order has been placed.";
    },
    currentStoreDoc(state) {
      return state.storeDoc;
    },
    viewConfig(state) {
      return state.ViewConfig;
    },
    storeLoaded(state) {
      return state.storeLoaded;
    },
    isGift(state) {
      return state.isGift;
    },
    hqDoc(state) {
      return state.HQDoc;
    },
    HQStore(state) {
      return state.HQStore;
    },
    getApplyMultiCoupon() {
      //TODO: this part must be get from firebase.
      return false;
    }
  }
};

function InitViewConfig(state, config) {
  var settings = {
    ShowNotes: config.ShowNotes || false,
    ShowNotesForItem: config.ShowNotesForItem || false,
    LogIn: config.LogIn || false,
    PickUp: config.PickUp || false,
    Delivery: config.Delivery || false,
    DeliverToRoom: config.DeliverToRoom || false,
    ChargeToRoomRadio: config.ChargeToRoomRadio === false ? false : true,
    EnableCashOnPickup: config.EnableCashOnPickup || false,
    EnableAlipayPayment: config.EnableAlipayPayment || false,
    EnableWechatPayment: config.EnableWechatPayment || false,
    EatIn: config.EatIn || false,
    ShowDeliveryDatePicker: config.ShowDeliveryDatePicker || false,
    ShowPickupDatePicker: config.ShowPickupDatePicker || false,
    HideAddressOnPickup: config.HideAddressOnPickup || false,
    ShowTrackingOrderForGuest: config.ShowTrackingOrderForGuest || false,
    ImageCenterMode: config.ImageCenterMode || false,
    FacebookLogin: config.FacebookLogin != false,
    GoogleLogin: config.GoogleLogin != false
  };
  if (!config.UiColours) {
    config.UiColours = {
      Mobile: {},
      Desktop: {}
    };
  }
  var colors = state.ViewConfig.UiColours;
  var mobileAgent = DetectMobile.methods.isMobile();

  if (mobileAgent) {
    config.UiColours.Mobile = config.UiColours.Mobile || {};
    var mobile = config.UiColours.Mobile;
    if (mobile) {
      colors.Mobile = {
        ButtonColour: mobile.ButtonColour || defaultMobileColors.ButtonColour,
        ButtonText: mobile.ButtonText || defaultMobileColors.ButtonText,
        CommonColor: mobile.CommonColor || defaultMobileColors.CommonColor,
        MenuHighlight:
          mobile.MenuHighlight || defaultMobileColors.MenuHighlight,
        MenuHighlightedText:
          mobile.MenuHighlightedText || defaultMobileColors.MenuHighlightedText,
        StatusPending:
          mobile.StatusPending || defaultMobileColors.StatusPending,
        TitleBar: mobile.TitleBar || defaultMobileColors.TitleBar
      };
    }
  } else {
    config.UiColours.Desktop = config.UiColours.Desktop || {};
    var desktop = config.UiColours.Desktop;
    if (desktop) {
      colors.Desktop = {
        ButtonColour: desktop.ButtonColour || defaultDesktopColors.ButtonColour,
        ButtonText: desktop.ButtonText || defaultDesktopColors.ButtonText,
        CommonColor: desktop.CommonColor || defaultDesktopColors.CommonColor,
        MenuHighlight:
          desktop.MenuHighlight || defaultDesktopColors.MenuHighlight,
        MenuHighlightedText:
          desktop.MenuHighlightedText ||
          defaultDesktopColors.MenuHighlightedText,
        StatusPending:
          desktop.StatusPending || defaultDesktopColors.StatusPending,
        TitleBar: desktop.TitleBar || defaultDesktopColors.TitleBar
      };
    }
  }
  state.ViewConfig = { ...state.ViewConfig, ...settings };
}
